import { ArrowRightOutlined } from '@ant-design/icons';
import RouterButton from '../../../common/RouterButton/RouterButton';

//all sales summary map
export const ALL_SALES_SUMMARY_MAP = [
    { title: '매출', id: 'sales', apiKeys: ['sales', 'amount', 'total'], unit: '원' },
    { title: '포인트 사용액', id: 'pointsUsed', apiKeys: ['sales', 'point', 'total'], unit: '원' },
    { title: '결제건', id: 'salesCount', apiKeys: ['sales', 'count', 'total'], unit: '건' },
    { title: '환불', id: 'refunds', apiKeys: ['refunds', 'amount'], unit: '원' },
    { title: '전체', id: 'totalUsers', apiKeys: ['members', 'total'], unit: '명' },
    { title: '탈퇴자 수 ', id: 'deletedUsers', apiKeys: ['members', 'deleted'], unit: '명' },
    {
        title: '미니앱 클릭수 ',
        id: 'mini_app_click_count',
        routeLabel: '클릭 수 보러가기',
        route: (label) => (
            <RouterButton href="/clickPercentage" gap={8}>
                {label}
                {<ArrowRightOutlined />}
            </RouterButton>
        ),
    },
    {
        title: '배너 클릭 수',
        id: 'banner_click_count',
        apiKeys: ['banner', 'click_count'],
        unit: '건',
        route: (label) => (
            <RouterButton href="/event" gap={8}>
                {label}
            </RouterButton>
        ),
    },
];

//sinor sales summary map
export const SINOR_SALES_SUMMARY_MAP = [
    { title: '매출', id: 'sales', apiKeys: ['sales', 'amount', 'total'], unit: '원' },
    { title: '포인트 사용액', id: 'pointsUsed', apiKeys: ['sales', 'point', 'total'], unit: '원' },
    { title: '결제건', id: 'salesCount', apiKeys: ['sales', 'count', 'total'], unit: '건' },
    { title: '환불', id: 'refunds', apiKeys: ['refunds', 'amount'], unit: '원' },
    { title: '전체', id: 'totalUsers', apiKeys: ['members', 'total'], unit: '명' },
    { title: '탈퇴자 수 ', id: 'deletedUsers', apiKeys: ['members', 'deleted'], unit: '명' },
    {
        title: '신규 모임 수 ',
        id: 'gathering',
        unit: '건',
        apiKeys: ['gathering', 'count'],
        route: (label) => (
            <RouterButton href="/gathering" gap={8}>
                {label}
            </RouterButton>
        ),
    },
    {
        title: '신규 게시글 / 일정 수',
        id: 'gathering-content',
        apiKeys: ['gathering', 'content', 'post_count'],
        apiKeys2: ['gathering', 'content', 'event_count'],
        unit: '건',
        route: (label) => (
            <RouterButton href="/gathering/contents" gap={8}>
                {label}
            </RouterButton>
        ),
    },
];
//silove sales summary map
export const SILOVE_SALES_SUMMARY_MAP = [
    { title: '매출', id: 'sales', apiKeys: ['sales', 'amount', 'total'], unit: '원' },
    { title: '포인트 사용액', id: 'pointsUsed', apiKeys: ['sales', 'point', 'total'], unit: '원' },
    { title: '결제건', id: 'salesCount', apiKeys: ['sales', 'count', 'total'], unit: '건' },
    { title: '환불', id: 'refunds', apiKeys: ['refunds', 'amount'], unit: '원' },
    { title: '전체', id: 'totalUsers', apiKeys: ['members', 'total'], unit: '명' },
    { title: '탈퇴자 수 ', id: 'deletedUsers', apiKeys: ['members', 'deleted'], unit: '명' },
    {
        title: '편지 발송 수 ',
        id: 'letter',
        unit: '건',
        apiKeys: ['communications', 'letter', 'sent_count'],
        route: (label) => (
            <RouterButton href="/letter" gap={8}>
                {label}
            </RouterButton>
        ),
    },
    {
        title: '채팅 수 (편지 / 88다방)',
        id: 'chat',
        apiKeys: ['communications', 'letter', 'chat_count'],
        apiKeys2: ['communications', 'dabang88', 'chat_count'],
        unit: '건',
        route: (label) => (
            <RouterButton href="/chatting" gap={8}>
                {label}
            </RouterButton>
        ),
    },
];
